import React from 'react';
import {Form} from '../../../components/form/Form';
import {useAppStateContext} from '../../../providers/AppState';
import {useFormSubmit} from '../../../controllers/useSubmitForm';

export const ReferralCandidateForm = props => {
  const {
    route: {
      params: {job_opening},
    },
  } = props;
  const {
    user: {
      employee: {_id: employeeId},
    },
  } = useAppStateContext();

  const {onSubmit} = useFormSubmit({
    uri: '/referralCandidates',
    eventSourceId: 'ReferralCandidate',
  });

  return (
    <Form
      header={{
        title: 'Refer Candidate',
        secondaryTitle: job_opening?.position_title?.name,
      }}
      defaultValues={{
        job_opening: job_opening?._id,
        referred_by: employeeId,
      }}
      onSubmit={onSubmit}
      layoutFields={[
        {
          label: 'Name',
          field: 'name',
          type: 'text',
          required: true,
          size: 6,
        },
        {
          label: 'Email',
          field: 'email',
          type: 'text',
          required: true,
          size: 6,
        },
        {
          label: 'Mobile',
          field: 'mobile',
          type: 'text',
          required: true,
          size: 6,
        },
        {
          palceholder: 'Upload CV',
          field: 'attachment',
          type: 'file',
          required: true,
          size: 6,
        },
      ]}
      {...props}
    />
  );
};

export const EditRefferalCandidate = props => {
  const {
    route: {
      params: {referral_candidate},
    },
  } = props;
  return (
    <ReferralCandidateForm
      header="Update Referral Candidate"
      mode="edit"
      api={'/referralCandidates/' + referral_candidate._id}
      fields={{
        name: 1,
        email: 1,
        mobile: 1,
        attachment: 1,
      }}
      {...props}
    />
  );
};

export const ReferralCandidateCommentForm = props => {
  const {
    route: {
      params: {referral_candidate},
    },
  } = props;

  const {onSubmit} = useFormSubmit({
    uri: '/referralCandidates',
    eventSourceId: 'ReferralCandidate',
  });

  return (
    <Form
      header={{
        title: 'Reject Referral Candidate',
        secondaryTitle: referral_candidate.name,
      }}
      mode="edit"
      api={'/referralCandidates/' + referral_candidate._id}
      fields={{
        comment: 1,
      }}
      beforeSubmit={({data}) => {
        return {
          data: {
            ...data,
            status: 'Rejected',
            closed_date: new Date(),
            rejected_date: new Date(),
          },
        };
      }}
      onSubmit={onSubmit}
      layoutFields={[
        {
          label: 'Comment',
          field: 'comment',
          type: 'textArea',
        },
      ]}
    />
  );
};

export const AddReferralToOtherOpening = props => {
  const {
    route: {
      params: {referral_candidate},
    },
  } = props;

  const {onSubmit} = useFormSubmit({
    uri: '/addReferralToOpening',
    eventSourceId: 'ReferralCandidate',
  });

  return (
    <Form
      header={{
        title: 'Add To Another Opening',
        secondaryTitle: referral_candidate.name,
      }}
      mode="edit"
      api={'/referralCandidates/' + referral_candidate._id}
      fields={{
        _id: 1,
        name: 1,
        email: 1,
        mobile: 1,
        attachment: 1,
        job_opening: {
          position_title: {
            name: 1,
          },
        },
      }}
      onSubmit={onSubmit}
      layoutFields={[
        {
          label: 'New Job Opening',
          field: 'job_opening',
          type: 'autoComplete',
          api: '/jobOpenings',
          suggestionField: 'position_title.name',
          required: true,
          filter: {
            status: 'Active',
          },
          fields: {
            position_title: {
              name: 1,
            },
          },
          getDisplayValue: ({value}) => value?.position_title?.name,
        },
      ]}
    />
  );
};

export const DraftCandidateCommentForm = props => {
  const {
    route: {
      params: {candidate},
    },
  } = props;

  const {onSubmit} = useFormSubmit({
    uri: '/candidates',
    eventSourceId: 'candidate',
  });

  return (
    <Form
      header={{
        title: 'Reject Candidate',
        secondaryTitle: candidate?.name,
      }}
      mode="edit"
      api={'/candidates/' + candidate._id}
      fields={{
        comment: 1,
      }}
      beforeSubmit={({data}) => {
        return {
          data: {
            ...data,
            status: 'Rejected',
          },
        };
      }}
      onSubmit={onSubmit}
      layoutFields={[
        {
          label: 'Comment',
          field: 'comment',
          type: 'textArea',
        },
      ]}
    />
  );
};

export const AddOpeningToCandidate = props => {
  const {
    route: {
      params: {candidate},
    },
  } = props;

  const {onSubmit} = useFormSubmit({
    uri: '/candidates',
    eventSourceId: 'candidate',
  });

  return (
    <Form
      header={{
        title: 'Add Job Opening',
        secondaryTitle: candidate.name,
      }}
      mode="edit"
      api={'/candidates/' + candidate._id}
      fields={{
        _id: 1,
        name: 1,
        email: 1,
        mobile: 1,
        attachment: 1,
        job_opening: {
          position_title: {
            name: 1,
          },
        },
      }}
      beforeSubmit={({data}) => {
        return {
          data: {
            ...data,
            status: 'Sortlisted',
            draft_candidate_active_date: new Date(),
          },
        };
      }}
      onSubmit={onSubmit}
      layoutFields={[
        {
          label: 'New Job Opening',
          field: 'job_opening',
          type: 'autoComplete',
          api: '/jobOpenings',
          suggestionField: 'position_title.name',
          required: true,
          filter: {
            status: 'Active',
          },
          fields: {
            position_title: {
              name: 1,
            },
          },
          getDisplayValue: ({value}) => value?.position_title?.name,
        },
      ]}
    />
  );
};
